import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';
import type { Action } from 'redux';

const initialState: IEmployeeTalkTemplate[] = [];

export enum EETTAction {
    ADD_ETT = 'ADD_ETT',
    SET_ETTS = 'SET_ETTS',
    DELETE_ETT = 'DELETE_ETT',
    UPDATE_ETT = 'UPDATE_ETT',
}

interface SetETTsAction extends Action {
    type: EETTAction.SET_ETTS;
    payload: IEmployeeTalkTemplate[];
}

interface DeleteETTAction extends Action {
    type: EETTAction.DELETE_ETT;
    payload: number; // Assuming the unique identifier is a number
}

interface UpdateETTAction extends Action {
    type: EETTAction.UPDATE_ETT;
    payload: IEmployeeTalkTemplate;
}
interface AddETTAction extends Action {
    type: EETTAction.ADD_ETT;
    payload: IEmployeeTalkTemplate;
}

type ETTAction = SetETTsAction | DeleteETTAction | UpdateETTAction | AddETTAction;

export const ettReducer = (state = initialState, action: ETTAction): IEmployeeTalkTemplate[] => {
    switch (action.type) {
        case EETTAction.ADD_ETT:
            return [...state, action.payload];
        case EETTAction.SET_ETTS:
            return action.payload;
        case EETTAction.DELETE_ETT:
            return state.filter((ett) => ett.id !== action.payload);
        case EETTAction.UPDATE_ETT: {
            // eslint-disable-next-line no-case-declarations
            const index = state.findIndex((ett) => ett.id === action.payload.id);
            if (index !== -1) {
                const newState = [...state];
                newState[index] = action.payload;
                return newState;
            } else {
                return [...state, action.payload];
            }
        }
        default:
            return state;
    }
};

// Action Creators
export const setETTs = (projects: IEmployeeTalkTemplate[]): SetETTsAction => ({
    type: EETTAction.SET_ETTS,
    payload: projects,
});

export const deleteETT = (id: number): DeleteETTAction => ({
    type: EETTAction.DELETE_ETT,
    payload: id,
});

export const updateETT = (project: IEmployeeTalkTemplate): UpdateETTAction => ({
    type: EETTAction.UPDATE_ETT,
    payload: project,
});

export const addETT = (project: IEmployeeTalkTemplate): AddETTAction => ({
    type: EETTAction.ADD_ETT,
    payload: project,
});
